const initialState = {
    userName:""
};

const userProfileReducer = (state=initialState,action:any)=>{

    switch(action.type){
        case "Changed": {
            return {...state, ...action.payload}
        }
        default:{
            return state
        }
    }
}
export default userProfileReducer;